module.exports = __webpack_public_path__ + "gr.svg?a69193c324ff6664634205efe897ea1d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gr.svg
// module id = 1264
// module chunks = 27